/**
 * ObjectDateTimeField React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// 3rd party components
import {DateTimePicker} from 'material-ui-pickers';


/**
 * ObjectDateTimeField is an editing component for date and time fields of objects
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
export class ObjectDateTimeField extends React.Component {

    render() {

        return <DateTimePicker
            keyboard
            label={this.props.fieldDef.name}
            format="dd.MM.yyyy HH:mm"
            mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/]}
            ampm={false}
            value={this.props.value ? new Date(this.props.value) : null}
            disabled={this.props.readOnly}
            clearable={true}
            onChange={value => this.props.onObjectValueChange(
                this.props.fieldDef.id, value != null ? value.toISOString() : undefined
            )}
            disableOpenOnEnter
            fullWidth={true}
            margin="normal"
            invalidDateMessage="ungültiges Format"
        />;
    }
}

ObjectDateTimeField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

export default ObjectDateTimeField;